import React from 'react';
import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';

import BWAccordion from 'components/shared/BWAccordion';
import FormInput from 'components/shared/BWFormControl/FormInput';
import { PortalIcon } from 'utils/baochauTheme';

const StatusWrapper = styled.div`
  .bw_coupon_status_card {
    padding: 15px 16px;
    border: 1px solid #e4e7ec;
    border-radius: 12px;
    background: #fcfcfd;
    transition:
      border-color 0.18s ease,
      background-color 0.18s ease,
      box-shadow 0.18s ease;
  }

  .bw_coupon_status_card.is-active {
    border-color: #a6e3bf;
    background: #f6fef9;
    box-shadow: 0 0 0 3px rgba(18, 183, 106, 0.07);
  }

  .bw_coupon_status_card.is-disabled {
    opacity: 0.7;
  }

  .bw_coupon_status_toggle {
    position: relative;
    display: grid;
    grid-template-columns: 42px minmax(0, 1fr) 46px;
    gap: 14px;
    align-items: center;
    cursor: pointer;
  }

  .bw_coupon_status_toggle.is-disabled {
    cursor: not-allowed;
  }

  .bw_coupon_status_input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  .bw_coupon_status_icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 11px;
    background: #f2f4f7;
    color: #667085;
    font-size: 19px;
  }

  .bw_coupon_status_card.is-active .bw_coupon_status_icon {
    background: #d1fadf;
    color: #039855;
  }

  .bw_coupon_status_title {
    display: block;
    margin-bottom: 3px;
    color: #101828;
    font-size: 14px;
    font-weight: 700;
  }

  .bw_coupon_status_description {
    display: block;
    color: #667085;
    font-size: 12.5px;
    line-height: 18px;
  }

  .bw_coupon_status_switch {
    position: relative;
    width: 46px;
    height: 26px;
    border-radius: 999px;
    background: #d0d5dd;
    transition: background-color 0.18s ease;
  }

  .bw_coupon_status_switch::after {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.25);
    content: '';
    transition: transform 0.18s ease;
  }

  .bw_coupon_status_card.is-active .bw_coupon_status_switch {
    background: #12b76a;
  }

  .bw_coupon_status_card.is-active .bw_coupon_status_switch::after {
    transform: translateX(20px);
  }
`;

const CouponStatus = ({ disabled, title = 'Trạng thái' }) => {
  const { watch } = useFormContext();
  const isActive = Boolean(watch('is_active'));

  return (
    <BWAccordion title={title}>
      <StatusWrapper className='bw_frm_box'>
        <div className={`bw_coupon_status_card ${isActive ? 'is-active' : ''} ${disabled ? 'is-disabled' : ''}`}>
          <label className={`bw_coupon_status_toggle ${disabled ? 'is-disabled' : ''}`}>
            <FormInput className='bw_coupon_status_input' disabled={disabled} type='checkbox' field='is_active' />
            <span className='bw_coupon_status_icon'>
              <PortalIcon icon={isActive ? 'fi fi-rr-check' : 'fi fi-rr-pause'} />
            </span>
            <span>
              <span className='bw_coupon_status_title'>
                {isActive ? 'Coupon đang hoạt động' : 'Coupon đang tạm ngưng'}
              </span>
              <span className='bw_coupon_status_description'>
                {isActive
                  ? 'Khách hàng có thể sử dụng coupon khi đáp ứng đủ điều kiện.'
                  : 'Coupon được lưu nhưng không thể áp dụng vào đơn hàng.'}
              </span>
            </span>
            <span className='bw_coupon_status_switch' />
          </label>
        </div>
      </StatusWrapper>
    </BWAccordion>
  );
};

export default CouponStatus;
